import {remCalc} from '../../_utils'

/**
 * the out of stock component style
 */
export default {
    baseStyle: {
        container: {
            flexDirection: 'row',
            gap: {base: 'xxxsmall.base', md: 'xxxsmall.md', lg: 'xxxsmall.lg', xl: 'xxxsmall.xl'},
            justifyContent: 'flex-start',
            alignItems: 'center',
        },
        icon: {
            boxSize: remCalc(12),
        },
        text: {
            color: 'foreground.neutral.subtle',
            fontWeight: 'regular',
            textStyle: 'body-xsmall',
        },
    },
    variants: {
        outOfStock: {
            icon: {fill: 'text.danger', backgroundColor: 'text.danger'},
            text: {color: 'text.danger'},
        },
        // lastFewItems: {
        //     icon: {backgroundColor: 'text.default', color: 'text.inverse'},
        // },
        preorder: {
            icon: {backgroundColor: 'null', color: 'text.inverse'},
            text: {
                color: 'text.success',
            },
        },
        'braun-out-of-stock': {
            icon: {
                fill: 'text.danger',
                backgroundColor: null,
                verticalAlign: 'middle',
                borderRadius: remCalc(0),
            },
            text: {
                color: 'text.danger',
                fontWeight: 'light',
                textStyle: 'body-xsmall',
                marginTop: remCalc(0),
            },
        },
        'braun-last-few-items': {
            icon: {backgroundColor: 'null', color: 'text.inverse'},
            text: {fontWeight: 'light', textStyle: 'body-xsmall', marginTop: remCalc(0)},
        },
        'braun-preorder': {
            icon: {backgroundColor: 'null', color: 'text.inverse'},
            text: {
                color: 'text.success',
                fontWeight: 'light',
                textStyle: 'body-xsmall',
                marginTop: remCalc(0),
            },
        },
        selector: {
            icon: {
                display: 'none',
            },
            text: {
                margin: 0,
                color: 'text.inverse',
                textStyle: 'body-xsmall',
                lineHeight: remCalc(16),
                backgroundColor: 'text.secondary',
                paddingX: remCalc(4),
                paddingY: remCalc(2),
                borderRadius: remCalc(4),
            },
        },
    },
    parts: ['icon', 'text', 'container', 'titleText', 'descriptionText'],
}
